import React from 'react'
import { SvgIcon } from '@material-ui/core'

const Bursie = (props) => {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g data-name="Group 6157">
        <g data-name="Group 6156">
          <path data-name="Path 14435" d="M92 572.252A6.209 6.209 0 0 1 99.748 580m-5.811-5.036a2.739 2.739 0 0 1 3.1 3.1" transform="translate(-79 -569)" strokeLinecap="round" strokeLinejoin="round" stroke="#363853" strokeWidth="1.5px" fill="none" />
          <path data-name="Path 14436" d="M94.165 589.883a7.671 7.671 0 0 0 2.669 0 3.7 3.7 0 0 0 2.951-2.459l.083-.267a2.867 2.867 0 0 0 .132-.857 2.431 2.431 0 0 0-2.541-2.3h-3.918A2.431 2.431 0 0 0 91 586.3a2.867 2.867 0 0 0 .131.854l.083.267a3.7 3.7 0 0 0 2.951 2.462zm0 0a15.04 15.04 0 0 1-12.049-12.048m0 0a7.709 7.709 0 0 1 0-2.67 3.7 3.7 0 0 1 2.46-2.951l.267-.083A2.85 2.85 0 0 1 85.7 572a2.431 2.431 0 0 1 2.3 2.541v3.918A2.431 2.431 0 0 1 85.7 581a2.85 2.85 0 0 1-.853-.131l-.267-.083a3.7 3.7 0 0 1-2.463-2.951z" transform="translate(-79 -569)" stroke="#363853" strokeWidth="1.5px" fill="none" />
        </g>
        <path data-name="Rectangle 5955" fill="none" d="M0 0h24v24H0z" />
      </g>
    </SvgIcon>
  )
}

export default Bursie
